export enum CuttingPlaneInfoStatus {
  HIDDEN = 0,
  VISIBLE = 1,
  INVERTED = 2,
}

export default class CuttingPlaneInfo {
  plane: Communicator.Plane | null;

  referenceGeometry: Communicator.Point3[] | null;

  status: CuttingPlaneInfoStatus;

  updateReferenceGeometry: boolean;

  constructor() {
    this.plane = null;
    this.referenceGeometry = null;
    this.status = CuttingPlaneInfoStatus.HIDDEN;
    this.updateReferenceGeometry = false;
  }
}
